var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.494 6.36018V11.3862C1.494 11.4852 1.579 11.5662 1.685 11.5662H3.893C3.999 11.5662 4.084 11.4852 4.084 11.3862V6.38418H5.581C5.678 6.38418 5.761 6.31618 5.771 6.22518L6 4.37518C6.00292 4.34974 6.00013 4.32397 5.99183 4.29975C5.98352 4.27553 5.96992 4.25347 5.952 4.23518C5.93346 4.21602 5.91123 4.20083 5.88665 4.19051C5.86207 4.1802 5.83566 4.17498 5.809 4.17518H4.084V3.01518C4.084 2.66518 4.285 2.48918 4.681 2.48918H5.808C5.914 2.48918 6 2.40918 6 2.30918V0.611176C6 0.511176 5.914 0.431176 5.808 0.431176H4.255L4.184 0.430176C3.914 0.430176 2.977 0.480176 2.237 1.11818C1.417 1.82518 1.531 2.67218 1.558 2.81918V4.17518H0.192C0.0859999 4.17518 0 4.25518 0 4.35518V6.18018C0 6.28018 0.0859999 6.36018 0.192 6.36018H1.494Z",
    fill: "#2866F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a730fc38eafa04e09cceef29ac155d8b.svg";
export { ForwardRef as ReactComponent };